<template>
  <div>
    <div class="pa-2">
      <v-layout>
        <v-flex shrink>
          <p class="small" style="margin-top: 10px;">{{ $t('User input') }}</p>
        </v-flex>
        <v-flex class="text-xs-right" style="white-space: nowarp">
          <slot name="delete-connection"></slot>
          <AddSuggestUserInput @handleAddSugguestion="handleAddSugguestion" />
        </v-flex>
      </v-layout>

      <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
        <tags
          v-model="reply"
          :tags="replies"
          @tags-changed="addReplies"
          @before-adding-tag="checkQuickReply"
          style="margin-bottom: 5px;"
          :btnText="$t('Add choice')"
        ></tags>
        <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
        <span class="text-error" v-if="errorTag.length > 0">
          <template v-if="errorTag.includes('overmaxlength')">
            {{ $t('Message cannot be longer than 20 alphabets') }}
          </template>
          <template v-else-if="errorTag.includes('overtagmax')">
            {{ $t('Choices cannot be more than 10 items') }}
          </template>
          <template v-else-if="errorTag.includes('duplicate')">
            {{ $t('Duplicate Choice') }}
          </template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import AddSuggestUserInput from './AddSuggestUserInput.vue'
export default {
  props: ['value'],
  data() {
    return {
      reply: '',
      errorTag: [],
      replies: [],
      question: ''
    }
  },
  mounted() {
    this.question = this.value
    if (this.value && this.value != '') {
      var replies = this.value.split(',')
      replies.map(el => {
        this.replies.push({ text: el })
      })
    }
  },
  computed: {
    // replies: {
    //   get() {
    //     let vm = this
    //     if (vm.intent && vm.intent.questionText && vm.intent.questionText.input !== '') {
    //       // console.log(vm.intent.quick_reply)
    //       var quick_replies = []
    //       quick_replies = vm.intent.questionText.input.split(',')
    //       var result = []
    //       $.each(quick_replies, function(index, val) {
    //         result.push({ text: val })
    //       })
    //       return result
    //     } else {
    //       return []
    //     }
    //   },
    //   set(value) {
    //     let vm = this
    //     var result = []
    //     $.each(value, function(index, val) {
    //       result.push(val.text)
    //     })
    //     vm.intent.questionText.input = result.join(',')
    //   }
    // }
  },
  components: {
    Tags,
    AddSuggestUserInput
  },
  methods: {
    handleAddSugguestion(val) {
      const value = `{${val}}`
      if (!this.replies.some(reply => reply.text == value)) {
        this.replies.push({ text: value })
      }
    },
    addReplies(newTags) {
      this.replies = newTags
      if (this.replies.length) {
        var question = []
        this.replies.map(el => {
          question.push(el.text)
        })
        this.question = question.join(',')
      }
      this.$emit('input', this.question)
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      }
      // else if (this.replies.length >= 10) {
      //   this.errorTag.push('overtagmax')
      //   obj.error()
      // }
      else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/QuestionManage.vue